import { cn } from '@/lib/utils.ts'

import './spinner-icon.css'

export const SpinnerIcon = ({ className }: { className?: string }) => {
  return (
    <div className={cn('spinner-icon', className)}>
      <div className="blob top"></div>
      <div className="blob bottom"></div>
      <div className="blob left"></div>

      <div className="blob move-blob"></div>
    </div>
  )
}
